"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _Input = require("../../../common/styles/Input"),
    _locationSelectorResults = require("../styles/locationSelectorResults"),
    _LocationSelectorResult = _interopRequireDefault(require("./LocationSelectorResult"));

function LocationSelectorResults(a) {
  var b = a.getResultProps,
      c = a.suggestions,
      d = a.loading;
  return d || !c.length ? null : _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_Input.LIST_CONTAINER, _locationSelectorResults.RESULTS_CONTAINER, "location-selector__results-container")
  }, c.map(function (a) {
    return _react["default"].createElement(_LocationSelectorResult["default"], {
      key: a.description,
      suggestion: a,
      getResultProps: b
    });
  }), _react["default"].createElement(_LocationSelectorResult["default"], {
    key: "cant-find-result",
    suggestion: {
      description: "Can't find what you're looking for?"
    },
    getResultProps: b
  }));
}

var _default = (0, _react.memo)(LocationSelectorResults);

exports["default"] = _default;